/** Тип перелёта в туре; значения совпадают с тем, что отдаёт поиск в `TourProductDTO.flightType`. */
export enum FlightType {
  Charter = 'charter',
  Regular = 'regular',
}

/** Поля тура, от которых зависит его тип подтверждения. */
export interface TourConfirmationSource {
  hotelAvailable: number;
  operatorId: number | null;
  flightType: FlightType;
}

interface DepartureCity {
  id: number;
  name: string;
}

interface Nights {
  tour: number;
  hotel: number;
}

interface Country {
  cover: string;
  id: number;
  name: string;
}
interface Resort {
  country: number;
  id: number;
  isPopular: boolean;
  name: string;
}

interface TouristGroup {
  adults: number;
  infants: number;
  kids: number;
  kidsAges: number[];
}

interface RoomGroup {
  hash: string;
  room: string;
  touristGroup: TouristGroup;
}

export interface ApiTour {
  departureCity: DepartureCity;
  checkInDate: string;
  nights: Nights;
  resort: Resort;
  touristGroup: TouristGroup;
  roomGroups: RoomGroup[];
  country: Country;
}
